var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9681 2.03174C13.0364 1.10006 11.5258 1.1001 10.5942 2.03184L2.62751 9.99947C2.35663 10.2704 2.16623 10.6111 2.07749 10.9838L1.3471 14.0515C1.30689 14.2204 1.35718 14.3981 1.47995 14.5208C1.60273 14.6436 1.78041 14.6939 1.94932 14.6537L5.01682 13.9233C5.38962 13.8346 5.73047 13.6441 6.00143 13.3731L13.9682 5.40541C14.8997 4.47376 14.8997 2.96334 13.9681 2.03174ZM11.3013 2.7389C11.8425 2.19773 12.7198 2.19771 13.261 2.73885C13.8021 3.27994 13.8021 4.15722 13.261 4.69835L12.6668 5.29265L10.7072 3.33309L11.3013 2.7389ZM10.0002 4.04024L11.9597 5.99979L5.29429 12.666C5.15419 12.8061 4.97795 12.9046 4.7852 12.9505L2.5081 13.4927L3.0503 11.2155C3.09618 11.0228 3.19462 10.8466 3.33466 10.7065L10.0002 4.04024Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.93bd30f73b4e3afe0ccb3d05a0853ab1.svg";
export { ForwardRef as ReactComponent };